var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 4.25H3.54167H14.875",
    stroke: "#C82929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4584 4.25008V14.1667C13.4584 14.5425 13.3092 14.9028 13.0435 15.1685C12.7778 15.4342 12.4175 15.5834 12.0417 15.5834H4.95841C4.58269 15.5834 4.22236 15.4342 3.95668 15.1685C3.691 14.9028 3.54175 14.5425 3.54175 14.1667V4.25008M5.66675 4.25008V2.83341C5.66675 2.45769 5.816 2.09736 6.08168 1.83168C6.34736 1.566 6.70769 1.41675 7.08341 1.41675H9.91675C10.2925 1.41675 10.6528 1.566 10.9185 1.83168C11.1842 2.09736 11.3334 2.45769 11.3334 2.83341V4.25008",
    stroke: "#C82929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08325 7.79175V12.0417",
    stroke: "#C82929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91675 7.79175V12.0417",
    stroke: "#C82929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash2);
export default __webpack_public_path__ + "static/media/trash-2.1870b1bc2e4eae4c1ecc21034b9cd00b.svg";
export { ForwardRef as ReactComponent };